export const pricingPlans = [
  {
    name: "Free Plan",
    price: 0,
    credits: 5,
    features: [
      "**5 Free Job Applications**",
      "Automated Job Search",
      "ChatGPT-4.1 Autofill (basic)",
      "LinkedIn Easy Apply Automation",
      "Secure Browser Extension",
      "Resume Builder (basic)",
      "No Payment — Direct Login",
    ],
    baseApplications: 5,
    customizedApplications: 0,
    free: true,
  },
  {
    name: "Starter Pack",
    price: 500,
    credits: 100,
    features: [
      "**100 Application Credits**",
      "Automated Job Search",
      "ChatGPT-4.1 Autofill",
      "LinkedIn Easy Apply Automation",
      "Secure Browser Extension",
      "Resume Builder Access",
      "Basic Support",
    ],
    baseApplications: 100,
    customizedApplications: 20,
  },
  {
    name: "Pro Pack",
    price: 1500,
    credits: 375,
    features: [
      "**375 Application Credits**",
      "Automated Job Search",
      "ChatGPT-4.1 Autofill",
      "LinkedIn Easy Apply Automation",
      "Non-stop Auto-Apply",
      "Resume Builder Access",
      "Secure Browser Extension",
      "Priority Support",
    ],
    popular: true,
    baseApplications: 375,
    customizedApplications: 75,
  },
  {
    name: "Premium Pack",
    price: 3000,
    credits: 1000,
    features: [
      "**1000 Application Credits**",
      "Automated Job Search",
      "ChatGPT-4.1 Autofill",
      "LinkedIn Easy Apply Automation",
      "Non-stop Auto-Apply",
      "Resume Builder Pro",
      "Secure Browser Extension",
      "Premium Chat Support",
    ],
    baseApplications: 1000,
    customizedApplications: 200,
  },
];

export default pricingPlans;
